// Professional Identity Integration P1 — shared helpers connecting opportunity
// surfaces (Property / Buyer Need) to the CANONICAL Public Professional Profile.
// The link is present only when the backend marks the owner's profile as published.
import { trackEvent } from "@/lib/track";

// Public-safe canonical profile path (/pro/:slug) or null when not published/eligible.
export const proProfilePath = (owner) => (owner && owner.public_profile_path) || null;

// Lightweight, PII-free analytics event fired when a professional identity is opened.
// source: property_card | property_detail | buyer_need_card | buyer_need_detail
export function trackProfileClick(owner, source) {
  trackEvent("professional_identity_click", {
    entity_type: "professional",
    entity_id: (owner && owner.public_slug) || null,
    metadata: { source: source || null, published: !!(owner && owner.public_profile_path) },
  });
}
